import { render, staticRenderFns } from "./wxl-notify-view.vue?vue&type=template&id=6b95cc54&scoped=true"
import script from "./wxl-notify-view.vue?vue&type=script&lang=js"
export * from "./wxl-notify-view.vue?vue&type=script&lang=js"
import style0 from "./wxl-notify-view.vue?vue&type=style&index=0&id=6b95cc54&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b95cc54",
  null
  
)

export default component.exports